<header name="header" class="content logo">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-5 col-10">
                <div class="logotipo">
                    <img src="../assets/images/dra-vanessa-lago-pneumologista2.png"
                        alt="Dra Vanessa Lago - Pneumologista - Botucatu, SP">
                    <div class="txt">
                        <h1>Dra. Vanessa Lago</h1>
                        <h2>Pneumologista</h2>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 col-md-7 col-2">
                <div [ngClass]="setMenuClass()">
                    <div class="btn-menu" (click)="onBtnMenuClick()">
                        <i class="icon bi bi-list"></i>
                        <i class="icon-close bi bi-x"></i>
                    </div>
                    <ul>
                        <li (click)="scroll('consultas-e-exames')"><span class="item">Consultas e Exames</span></li>
                        <li (click)="scroll('curriculo')"><span class="item">Currículo</span></li>
                        <li (click)="scroll('atendimento')"><span class="item">Atendimento</span></li>
                        <li (click)="scroll('agendar')"><span class="item">Agendar</span></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>